import { action } from "typesafe-actions";

import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";

import { IGoogleReview, IReviewResponseConfig } from "./review.types";
import { IStoreState } from "../initialStoreState";
import { api } from "../../api/api";
import {
	saveLoaderCompleted,
	saveLoaderProgress,
	showMessage,
} from "../messages/messagesActions";
import { uploadFile } from "../../helpers/uploadFile";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";

export const FETCH_GOOGLE_REVIEW_LIST_PROGRESS =
	"FETCH_GOOGLE_REVIEW_LIST_PROGRESS";
export const FETCH_GOOGLE_REVIEW_LIST_SUCCESS =
	"FETCH_GOOGLE_REVIEW_LIST_SUCCESS";
export const FETCH_GOOGLE_REVIEW_LIST_FAILED =
	"FETCH_GOOGLE_REVIEW_LIST_FAILED";

export const fetchGoogleReviewListProgress = () =>
	action(FETCH_GOOGLE_REVIEW_LIST_PROGRESS);
export const fetchGoogleReviewListSuccess = (data: IGoogleReview[]) =>
	action(FETCH_GOOGLE_REVIEW_LIST_SUCCESS, { data });
export const fetchGoogleReviewListFailed = () =>
	action(FETCH_GOOGLE_REVIEW_LIST_FAILED);

export const fetchGoogleReviewListAsync =
	(
		pageNumber: number,
		rowsInPerPage: number,
		limit: number,

		date: IDataTableV2DateState["dates"]
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			dispatch(fetchGoogleReviewListProgress());
			const res = await api.get(
				`/review/google-reviews?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`
			);
			const data: IGoogleReview[] = res.data.data;
			dispatch(fetchGoogleReviewListSuccess(data));
		} catch (err: any) {
			dispatch(fetchGoogleReviewListFailed());
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.message,
					displayAs: "snackbar",
				})
			);
		}
	};

export const upsertReviewResponseConfigAsync =
	(
		review: IReviewResponseConfig,
		onCallBack: (isSuccess?: boolean, data?: IReviewResponseConfig) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		dispatch(saveLoaderProgress());
		try {
			const { ...rest } = review;
			const res = await api.post("/review/analyze-review", rest);
			dispatch(
				showMessage({
					type: "success",
					message: res.data.message,
					displayAs: "snackbar",
				})
			);
			const data = res.data.data;
			onCallBack(true, data);
		} catch (err: any) {
			onCallBack(false);
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.error,
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(saveLoaderCompleted());
		}
	};
